module.exports = __webpack_public_path__ + "static/img/picture4.768c42a9.png";